<script setup lang="ts">
const language = ref('en')

const toggleLanguage = () => {
  language.value = language.value === 'en' ? 'zh' : 'en'
}

useHead({
  script: [
    {
      type: 'text/javascript',
      src: '/flowpaper/js/jquery.min.js'
    },
    {
      type: 'text/javascript',
      src: '/flowpaper/js/jquery.extensions.min.js'
    },
    {
      type: 'text/javascript',
      src: '/flowpaper/js/three.min.js'
    },
    {
      type: 'text/javascript',
      src: '/flowpaper/js/flowpaper.js'
    },
    {
      type: 'text/javascript',
      src: '/flowpaper/js/flowpaper_handlers.js'
    },
    {
      type: 'text/javascript',
      src: '/flowpaper/js/aboutUs2.js'
    }
  ],
  link: [
    {
      rel: 'stylesheet',
      type: 'text/css',
      href: '/flowpaper/css/flowpaper.css'
    }
  ]
})

</script>
<template>
  <div class="mb-6">
    <h1>ABOUT US</h1>

    <div class="text-center bg-black flex-col">
      <iframe
        v-if="language === 'en'"
        class="mx-auto"
        width="1000" height="562" src="https://www.youtube.com/embed/QNjDV8gQ964?si=_QoWb6ejcXbXwFyZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

      <iframe v-if="language === 'zh'"
        class="mx-auto" width="1000" height="562" src="https://www.youtube.com/embed/Z8ZjRBzXVL4?si=Uf1nIPknc6jCrEXb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      

      <div class="text-right text-white">
        <button @click="toggleLanguage" class="p-2">
          Watch in {{ language === 'en' ? 'chinese': 'english' }}
        </button>
      </div>
    </div>

    <div class="relative">
      <h2 class="font-bold text-xl mt-4">Cel-Elements Holdings (M) Sdn Bhd<sup class="ml-2 text-xs">since 2004</sup></h2>

      <div class="h-5 mb-6">
        <blockquote class="text-xl italic font-semibold text-gray-900 dark:text-white relative">
          <svg
            class="w-full w-8 h-8 absolute left-0 top-0 opacity-20 text-gray-800 dark:text-gray-600 mb-4"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 18 14"
          >
            <path
              d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z"
            />
          </svg>
          <p class="z-10 pt-4 pl-3">Where beauty meets excellence</p>
        </blockquote>
      </div>
    </div>

    <div class="p-2">
      <div class="flex">
        <div class="pt-2 px-4 text-justify">
          <h3 class="font-bold">Cel-Elements Holdings (M) Sdn Bhd: Where Beauty Meets Excellence</h3>

          <img src="/img/about/group-photo-lg.png" alt="cel elements group" class="photo float-right" />

          <p class="sm:mx-2 my-4 pt-2">
            In the heart of Malaysia, a beacon of beauty brilliance emerges – Cel-Elements Holdings (M) Sdn Bhd. With
            unwavering dedication to the world of beauty, we have honed our expertise to become a trusted name in the
            realm of skincare and cosmetics. Our journey is built upon the foundation of innovation and authenticity. We
            have meticulously crafted our own production lines, ensuring the highest standards of quality, purity, and
            safety.

            <br /><br />
            It's not just about beauty; it's about confidence, empowerment, and transformation. And we take pride in
            being at the forefront of this transformative experience. Our portfolio is a testament to our commitment to
            beauty in all its forms. From revitalizing skincare that nourishes your skin's deepest layers to cosmetics
            that enhance your natural allure, we offer a comprehensive range of products that cater to every
            individual's unique beauty needs.
          </p>
        </div>
      </div>
    </div>

    <div class="relative mt-4">
      <h2 class="font-bold text-lg">The founder</h2>
      <div class="p-2">
        <div class="flex">
          <div class="pt-2 px-4 text-justify">
            <h3 class="font-bold text-lg">Nelson Koo, Founder</h3>
            <h4 class="font-bold italic">The Visionary Beauty Maestro</h4>

            <img src="/img/about/nelson.png" alt="nelson" class="photo float-left" />

            <p class="sm:mx-2 my-4 pt-2">
              In the captivating realm of aesthetics, where the quest for perfection knows no limits, resides a
              luminary, Nelson Koo. As the illuminating force behind Cel-Elements Holdings (M) Sdn Bhd, Nelson
              personifies the company's essence. Nelson's venture into this world commenced with an unquenchable passion
              for the beautiful. It ran deeper than the surface; it was a profound commitment to self-expression through
              elegance.

              <br /><br />
              From a young age, he embraced the idea that beauty is not merely superficial but a potent source of
              self-confidence and empowerment. One might say Nelson was destined for greatness in this industry. His
              dedication to nurturing his skin's radiance was a testament to his commitment. He meticulously adhered to
              a daily routine, choosing the finest products and treating his face as a canvas. Each skincare ritual was
              a carefully orchestrated symphony, with him as the conductor ensuring perfection in every note.

              <br /><br />
              This passion for perfection led Nelson to establish Cel-Elements Holdings (M) Sdn Bhd. He envisioned a
              company offering high-quality products that nurtured the beauty enthusiast in everyone, aiming to share
              his profound understanding with the world. Nelson's unwavering dedication to quality and attention to
              finer details have become the core of Cel-Elements Holdings (M) Sdn Bhd. His relentless pursuit of
              excellence shines through every product, certification, and the radiant smiles of customers. Beyond
              business and credentials, Nelson embodies the transformative power of beauty, recognizing it as more than
              aesthetics – a source of self-confidence, self-love, and self-expression. As the founder, he invites you
              on a journey where beauty is not just a destination but a way of life. Nelson Koo, is a man whose
              boundless passion and dedication illuminate your radiant self through every product and moment of your
              beautiful experience.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="p-2">
      <div class="flex">
        <div class="pt-2 px-4 text-justify">
          <h3 class="font-bold text-lg">The Duo Soulmate</h3>
          <h4 class="font-bold italic">with over 20 years of experience in nurturing skin.</h4>
          <img src="/img/about/duo.png" alt="duo soulmate" class="photo float-right" />

          <p class="sm:mx-2 my-4 pt-2">
            Ms. Koo, a certified SKM Malaysia Level 3 Beautician with HRDF Train the Trainer qualifications, exudes
            sincerity and a strong desire to empower others.

            <br /><br />
            Sherine, boasting over two decades of experience as a beauty consultant, is a perfectionist with a
            compassionate ear for clients' concerns during consultations.

            <br /><br />
            Together, these sisters form a dynamic duo, infusing their individual strengths to create products that are
            visually stunning and scientifically advanced. Their united drive redefines beauty at Cel-Elements Holdings
            (M) Sdn Bhd, transforming it into a shared dream to empower individuals to embrace their unique beauty,
            overcoming skin challenges along the way.

            <br /><br />
            Ms. Koo and Sherine's combined expertise at the intersection of artistry and science has given birth to a
            beautiful world like no other. Their unwavering passion for the industry stems from their personal battles
            with skin challenges in their youth. Their shared commitment revolves around assisting individuals in
            addressing similar issues. The sisters aspire to offer solutions and empower those facing facial and skin
            problems, fueling their dedication to the beauty world.
          </p>
        </div>
      </div>
    </div>

    <div class="relative mt-4">
      <h2 class="font-bold text-lg">Stated-of-the-art Labotory</h2>
      <div class="p-2">
        <div class="flex">
          <div class="pt-2 px-4 text-justify">
            <h3 class="">
              At Cel-Elements Holdings (M) Sdn Bhd, we hold sacred certifications that guarantee the superiority of our
              products.
            </h3>

            <div class="gallery flex justify-center gap-1 h-[400px] my-6">
              <img src="/img/about/rd.png" alt="R & D" class="photo w-full h-full object-cover" />
              <img src="/img/about/product.png" alt="Product" class="photo w-full h-full object-cover" />
            </div>

            <div class="my-6 py-6 mx-4">
              <div class="text-center mb-2">
                Our dedication to excellence is evident through our prestigious
                <span class="font-bold">HALAL</span>, <span class="font-bold">ISO22716</span>,
                <span class="font-bold">GMP</span>, <span class="font-bold">FDA</span>, and
                <span class="font-bold">KKM</span>
                certifications, each a testament to our commitment to delivering the finest beauty solutions to our
                global clientele.
              </div>

              <div class="logos text-center items-center py-10 bg-white">
                <img src="/img/about/logo-eco-greenlife.png" alt="eco greenlift" class="" />
                <img src="/img/about/logo-au-organic.png" alt="australia organic" class="" />
                <img src="/img/about/logo-bdih.png" alt="bdih" class="" />
                <img src="/img/about/logo-cosmebio.png" alt="cosmebio" class="" />
                <img src="/img/about/logo-iso-22716.png" alt="iso-22716" class="" />
                <img src="/img/about/logo-gmp.png" alt="gmp" class="" />
                <img src="/img/about/logo-fda.png" alt="fda" class="" />
                <img src="/img/about/logo-taiwan-halal.png" alt="halal" class="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="relative mt-4">
      <h2 class="font-bold text-lg">Embarking on a corporate pilgrimage, we set our sights on Pemay Taiwan</h2>
      <div class="p-2">
        <div class="flex">
          <div class="pt-2 px-4 text-justify">
            <img src="/img/about/permay.png" alt="permay" class="photo float-right" />

            <p class="sm:mx-2 my-4 pt-2">
              Stepping into Pemay Taiwan was like entering a sanctuary of beauty and innovation. This corporate visit was more than just a routine examination; it was a voyage into the heart of Cel-Elements' essence.

              <br /><br />
              Amidst the state-of-the-art laboratories and meticulous quality control processes, we uncovered the magic behind Cel-Elements' beauty products. Each formulation, every delicate ingredient, was a labor of love, a symphony of science and artistry.
              <br/><br/>

              As we delved deeper into the examination work, we felt the dedication and precision that went into crafting these treasures. Pemay Taiwan was not just a partner but a guardian of Cel-Elements' commitment to excellence.
              <br/><br/>

              This visit was a reminder that every Cel-Elements product carries not only beauty but also the spirit of innovation, nurtured in the hallowed halls of Pemay Taiwan. It left us inspired, knowing that our journey for beauty perfection was in the right hands, and our future endeavors would continue to shine with the brilliance of Cel-Elements.

            </p>
          </div>
        </div>
      </div>
    </div> -->
    
    <div class="relative mt-4">
      <h2 class="font-bold text-lg">Meet the team</h2>
      <div class="p-2">
        <div class="flex">
          <div class="pt-2 px-4 text-justify">
            <img src="/img/about/team.png" alt="permay" class="photo float-left" />

            <p class="sm:mx-2 my-4 pt-2">
              
              Cel-Elements is not just a company; it's a harmonious blend of diverse talents and passions, all driven by a shared vision of beauty excellence. At the helm of this remarkable team is our founder and visionary, Nelson Koo, whose unwavering passion for beauty ignited the spark that became Cel-Elements.
              <br /><br />
              Guiding us with a steady hand is our Managing Director, whose leadership ensures that Cel-Elements continues to flourish and innovate in the world of beauty.
              <br/><br/>

              In the realm of aesthetics, our dedicated beauticians are the artists who bring beauty to life. With their artistic touch and unwavering commitment to perfection, they craft our skincare and cosmetics into works of art.
              <br/><br/>

              Our trainers are the pillars of knowledge, imparting wisdom and expertise to our team. They ensure that the Cel-Elements family is always at the cutting edge of beauty trends and techniques. Behind the scenes, our Marketing and Sales team is the driving force that brings our products to the world. They understand the beauty of our creations and share it with our global community, making beauty accessible to all.

              <br/>
              <br/>
              Together, this vibrant and passionate team is the heart and soul of Cel-Elements, dedicated to redefining beauty, one product at a time.

            </p>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="p-2">
      <p>
        Engineered by avant-garde biomedical technology since its inception in year 2004, Cel-Elements is a brand
        harnessing nature and research in creating authentic and respectful beauty care products.
      </p>
      <p>
        Fortified with patented complexes and tolerance of formulae tested under dermatological and medical
        surveillance, Cel-Elements products promise the absolute elite of care and protection in reviving resilience and
        radiance, of healthy and youthful skin.
      </p>
      <p>
        Leading steadfastly in the industry with new discoveries and fresh innovations, Cel-Elements strives to build
        and retain up-close and win-win collaboration with its partners and associates to realize an awe-insipiring
        beauty care experience.
      </p>

    </div>-->
    <!-- <div class="flex-col justify-center mb-10 px-4 ">
      <div id="documentViewer" class="h-[calc(80vh)] sm:h-[500px] mb-2" >
      </div>
      <a href="https://storage.cel-elements.com/celeleme%2F20240228%20CE%20Catalogue%20Vol%205_vers1.pdf" class="bg-blue-500 text-white font-bold py-2 px-8 rounded w-full text-center block" target="_blank">
        Download Company Profile
      </a>
    </div> -->

  </div>
</template>

<style scoped>
  .photo {
    @apply p-2 bg-white rounded-lg object-cover hover:scale-105 transition-transform duration-300 w-[600px] sm:w-[50%] m-0 my-2 sm:mx-4;
  }
  .logos img {
    @apply h-[80px] inline-block;
  }
</style>
